import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import variants from './AlertBox.variants';
import { Pill, Contents, IconContainer, WarningIcon, SuccessIcon, ErrorIcon } from './AlertBox.styles';

const AlertBox = ({ children, variant, className, dataCy = 'alert-box', tooltips }) => {
  const IconMap = {
    [AlertBox.variants.SUCCESS]: SuccessIcon,
    [AlertBox.variants.WARNING]: WarningIcon,
    [AlertBox.variants.ERROR]: ErrorIcon,
    [AlertBox.variants.INFO]: WarningIcon
  };

  const Icon = IconMap[variant];

  if (tooltips) {
    const tooltipText = tooltips.text.split('\n').join('<br/>');

    return (
      <Pill data-testid={dataCy} data-cy={dataCy} variant={variant} className={className}>
        <span data-for={tooltips.id} data-tip={tooltipText}>
          <IconContainer>
            <Icon />
          </IconContainer>
        </span>
        <ReactTooltip id={tooltips.id} data-cy={tooltips.id} html={true} />
        <Contents>{children}</Contents>
      </Pill>
    );
  }

  return (
    <Pill data-testid={dataCy} data-cy={dataCy} variant={variant} className={className}>
      <IconContainer>
        <Icon />
      </IconContainer>
      <Contents>{children}</Contents>
    </Pill>
  );
};

AlertBox.variants = variants;

AlertBox.propTypes = {
  className: PropTypes.string,
  dataCy: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf([...Object.values(variants)]),
  tooltips: PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  })
};

AlertBox.defaultProps = {
  variant: AlertBox.variants.SUCCESS
};

export default AlertBox;
